type AppConfig = {
  BASE_URL: string;
  ENV: string;
  FEATURES: string[];
  SSO?: SSOConfig;
};

type SSOConfig = {
  appIdUri: string;
  tenantId: string;
  frontendClientId: string;
  redirectUri: string;
};

let config: AppConfig;

export async function loadConfig() {
  if (typeof window === "undefined") {
    console.info("Skipping config load during SSR");
    return;
  }

  if (config) return; // If already loaded, skip fetching again

  const res = await fetch("/config.json");
  config = await res.json();
  console.info("Loading config from /config.json", config);
}

export function updateBaseUrl(newBaseUrl: string) {
  if (!config) {
    throw new Error("Config not loaded. Call loadConfig() first.");
  }

  config.BASE_URL = newBaseUrl;
  console.info("Updated BASE_URL to", newBaseUrl);
}

export function getConfig(): AppConfig {
  if (!config) {
    throw new Error("Config not loaded. Call loadConfig() first.");
  }

  return config;
}
